import { ReactNode, useState } from "react";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";

/*
 games 컴포넌트들을 lazy 하게 가져옵니다
 */
export const GamesWrapLazyContentsWebView = ({
  contents,
}: {
  contents: ReactNode;
}) => {
  const [visible, setVisible] = useState(false);

  const ref = useIntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) {
        setVisible(true);
      }
    },
    {
      threshold: 0.1,
      rootMargin: "10px 0px",
    },
  );

  return <section ref={ref}>{visible && contents}</section>;
};
